export default __webpack_public_path__ + "static/media/frequenttraveler-cat.7669b257.svg";